<template>
  <div class="enrolling-admission-adjust" v-loading="loading" element-loading-text="数据加载中...">
    <el-form size="mini" label-width="120px" label-suffix="：">
      <el-form-item label="调剂教学点">
        <el-select v-model="siteId" placeholder="请选择教学点" filterable>
          <el-option
            v-for="site in siteList"
            :key="site.id"
            :label="site.name"
            :value="site.id"
            :disabled="site.id === oldSiteId"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button size="mini" type="primary" :loading="submitting" @click="handleSubmit">确认调剂</el-button>
      <el-button size="mini" @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollingAdmissionAdjust',
  data () {
    return {
      loading: false,
      submitting: false,
      oldSiteId: '',
      siteId: '',
      siteList: [],
      studentId: ''
    }
  },
  methods: {
    loadSiteList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/query/adjustSiteList',
        method: 'post',
        data: this.$qs.stringify({ id: this.studentId })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.siteList = response.data.siteList || []
          this.oldSiteId = response.data.oldSiteId || ''
        } else {
          this.$message.error(response.data && response.data.message ? response.data.message : '教学点加载失败')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      if (!this.siteId) {
        this.$message.warning('请选择调剂教学点')
        return
      }
      this.submitting = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/query/adjust',
        method: 'post',
        data: this.$qs.stringify({ id: this.studentId, siteId: this.siteId })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.$message.success('调剂成功')
          this.oldSiteId = this.siteId
          this.$emit('hidePopoverAndRefresh')
        } else {
          this.$message.error(response.data && response.data.message ? response.data.message : '调剂失败')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.studentId = this.$attrs['extra-id']
    this.loadSiteList()
  }
}
</script>

<style lang="scss">
.enrolling-admission-adjust {
  padding: 20px;
  .footer {
    text-align: center;
    margin-top: 10px;
  }
}
</style>
